module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ed-modal', {
    attrs: {
      "title": 'DETALHAMENTO DA CONSULTA EXTERNA ' +
        (this.formData.consulta ?
          ' - ' + this.formData.consulta.funcionario.nome :
          ''),
      "modal": _vm.showConsultaDetail,
      "loading": _vm.loadingConsultaDetail,
      "width": "70%"
    }
  }, [_c('div', {
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, [_c('ConsultaDetalhe', {
    attrs: {
      "consulta": _vm.formData.consulta
    }
  })], 1)]), _vm._v(" "), _c('ed-modal', {
    attrs: {
      "title": 'ALTERAR PCMSO DA CONSULTA EXTERNA ' +
        (this.formData.consulta ?
          ' - ' + this.formData.consulta.funcionario.nome :
          ''),
      "modal": _vm.showAlterarRevisao,
      "onSave": _vm.onAlterarPcmso,
      "disabledSave": _vm.checkAlterarPcmso,
      "width": "70%"
    }
  }, [_c('div', {
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, [_c('ConsultaAlterarRevisao', {
    attrs: {
      "consulta": _vm.formData.consulta,
      "consultaNova": _vm.formData.consultaNova,
      "ultimaRevisao": _vm.formData.ultima_revisao
    }
  })], 1)]), _vm._v(" "), _c('TableView', {
    attrs: {
      "onSearch": _vm.getConsulta,
      "tableHead": _vm.tableHead,
      "tableData": _vm.tableData,
      "loadingTable": _vm.loadingTable,
      "pagination": _vm.pagination,
      "onFilter": _vm.getConsulta,
      "filterBadge": _vm.filterBadge,
      "response": _vm.response
    }
  }, [_c('div', {
    attrs: {
      "slot": "table-filter-content"
    },
    slot: "table-filter-content"
  }, [_c('ed-form', {
    attrs: {
      "data": _vm.formFilter,
      "config": _vm.config,
      "response": _vm.response,
      "itens": _vm.filterItems,
      "onClear": _vm.onClear
    }
  })], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-38cb077b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/web/consulta-externa/index.vue
// module id = 1451
// module chunks = 45